import {
  ButtonType,
  ButtonWidget,
  TextLinkWidget
} from '@tableau/widgets';
import * as React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import { HelpService } from '~src/commonInfra/services/HelpService';

import { TooltipAnchor } from '../../app/spaces/Tooltips/TooltipAnchor';
import { MapDispatchToProps } from '../../app/utils/ConnectUtils';
import { Messages } from '../../codegen/Localize';
import { CommonStyles } from '../../common/react/CommonStyles';
import { DeprecatedInterpolatedString } from '../../common/react/components/InterpolatedString';
import { imgPath } from '../../common/utilities/ImgUrl';
import { L10n } from '../../ts/L10n/L10n';
import { resumeMetricFromExplorer } from '../actions/UpdateMetricsActions';

export interface MetricSuspendedIndicatorOwnProps {
  metricId: string;
  metricRefreshedTimestamp: string;
  userCanResumeSuspendedMetric: boolean;
}

export interface MetricSuspendedIndicatorDispatchProps {
  resumeMetricFromExplorer: (metricId: string) => void;
}

export type MetricSuspendedIndicatorProps = MetricSuspendedIndicatorOwnProps & MetricSuspendedIndicatorDispatchProps;

export class MetricSuspendedIndicator extends React.PureComponent<MetricSuspendedIndicatorProps> {
  public render() {
    /* eslint-disable jsx-a11y/alt-text */
    return <TooltipAnchor tooltipContent={this.renderTooltipContent}
      useKeyboardToActivateTooltip={true}
      width={228}
      disableAutoFocus={!this.props.userCanResumeSuspendedMetric}
      title={Messages.viewTooltipTitle()}>
      <img
        tabIndex={-1} // disable tabbing in datagrid cells, leaving focus managed by datagrid itself
        src={imgPath('server_alert_list_suspended.svg')}
        style={{ verticalAlign: 'middle', marginRight: '4px' }}
        data-tb-test-id="metric-suspended-icon"
      />
    </TooltipAnchor>;
  }

  private renderTooltipContent = (): JSX.Element => {
    if (this.props.userCanResumeSuspendedMetric) {
      return (
        <div data-tb-test-id="metrics-suspended-indicator">
          <div>
            <DeprecatedInterpolatedString
              baseStringKey="metricSuspendedWithResumeTooltip"
              translate={() => Messages.metricSuspendedWithResumeTooltip({LEARN_MORE_LINK: '{LEARN_MORE_LINK}'})}
              replacements={{
                'SUSPEND_DATE': () => <span>{L10n.localizedDate(this.props.metricRefreshedTimestamp)}</span>,
                'LEARN_MORE_LINK': () =>
                  <TextLinkWidget
                    href={HelpService.getServerHelpUrlByCategory('metrics-suspend')}
                    target="_blank"
                    testId="metrics-resume-help"
                  >
                    {Messages.learnMore()}
                  </TextLinkWidget>
              }}
            />
          </div>
          <ButtonWidget
            buttonType={ButtonType.Outline}
            testId="metrics-resume"
            style={{ marginTop: CommonStyles.Sizes.MediumSpace }}
            onClick={() => this.props.resumeMetricFromExplorer(this.props.metricId)}
          >
            {Messages.metricResumeButtonLabel()}
          </ButtonWidget>
        </div>
      );
    } else {
      return <span>{Messages.metricSuspendedNoResumeTooltip()}</span>;
    }
  }
}

const mapDispatchToProps: MapDispatchToProps<MetricSuspendedIndicatorDispatchProps> = (dispatch) => bindActionCreators({
  resumeMetricFromExplorer
}, dispatch);

export const ConnectedMetricSuspendedIndicator = connect(undefined, mapDispatchToProps)(MetricSuspendedIndicator);

